import { BooleanStore } from 'stores';

import { ConnectedServices } from './connectedServices';

const connectedServicesStore = new ConnectedServices();
const showRaceDayDetailStore = new BooleanStore(false);

export { connectedServicesStore, showRaceDayDetailStore };
1;
